export default __webpack_public_path__ + "static/media/undraw_maker_launch_crhe.542826d6.svg";